export default __webpack_public_path__ + "static/suv-55a7a50b4f239f8b754f2a40c7b0d0ef.png";